import React from "react";

const Dots = ({ classname }) => {
  return (
    <div className={`grid grid-cols-5 gap-2 place-items-end ${classname}`}>
      <div className="w-3 h-3 rounded-full bg-customSlate-500" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 col-span-3 rounded-full bg-customSlate-500" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 col-span-4 rounded-full bg-customSlate-500" />
      <div className="w-3 h-3 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 col-span-5 rounded-full bg-customSlate-600" />
      <div className="w-3 h-3 col-span-5 rounded-full bg-customSlate-500" />
    </div>
  );
};

export default Dots;
